/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { Button } from '../../../components/Button/Button'
import { Input } from '../../../components/Input/Input'
import { useNavigate, useParams } from 'react-router-dom'
import { Loading } from '../../../components/Loading/Loading'
import Swal from 'sweetalert2'
import { i18n } from '../../../translate/i18n'
import { BreadCrumbs } from '../../../components/BreadCrumbs/breadCrumbrs'
import moment from 'moment-timezone'
import { UpdateAgregatorPublicityDto, typeBannerHotel, CreateAgregatorPublicityDto } from './agregador-publicity.type'
import { AggregatorClassification } from '../AggregadorCategory/aggregadorCategory.type'
import { LojaAgregador } from '../lojas/type'
import { deleteImage, getAgregadorClassification, getAgregadorStores, uploadImagesInForm, validateForm, validateImage } from './factory/helper.factory'
import { useAgregadorPublicity } from './factory/useAgregadorPublicity'
import useModals from '../../../hooks/useModals'
import { ModalImagemCropped } from '../../../components/Modals/ImagemCropped/ImagemCropped'
import { resizeImage } from '../dinamicPage/factory/dinamic-page.aux'


const AgregadorPublicityHighLightsEditar: FC = () => {
  const navigate = useNavigate()
  const { showImageCropped } = useModals()
  const { id } = useParams()
  const { setLoading, loading, getPublicityHighLightById, updatePublicityHighLight } = useAgregadorPublicity(typeBannerHotel.HIGHLIGHT)
  const [loadingRequest, setLoadingRequest] = useState(false)
  // Form state
  const [formData, setFormData] = useState<UpdateAgregatorPublicityDto>({
    image: '',
    aggregatorClassificationId: 0,
    pluginSpaceAggregatorId: 0,
    title: '',
    order: 1,
    startDate: '',
    type: typeBannerHotel.HIGHLIGHT,
    externalLink: '',
    description: '',
    endDate: '',
    status: true,
  })
  // Separate date and time states for better UX
  const [hasExternalLink, setHasExternalLink] = useState(false)
  const [startDateOnly, setStartDateOnly] = useState('')
  const [startTimeOnly, setStartTimeOnly] = useState('00:00:00')
  const [endDateOnly, setEndDateOnly] = useState('')
  const [endTimeOnly, setEndTimeOnly] = useState('23:59:59')
  const [stores, setStores] = useState<LojaAgregador[]>([])
  const [classification, setClassification] = useState<AggregatorClassification[]>([])
  // Handle input changes
  const [originalImageFile, setOriginalImageFile] = useState<File | null>(null)
  const [imageCrop, setImageCrop] = useState<string | null>('')
  const [isCropped, setCropper] = useState<any>(null)
  const [firstStateImage, setFirstStateImage] = useState<string | null>(null)

  const handleInputChange = (field: keyof UpdateAgregatorPublicityDto, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  // Update combined datetime when date or time changes
  useEffect(() => {
    if (startDateOnly && startTimeOnly) {
      setFormData((prev) => ({
        ...prev,
        startDate: moment(`${startDateOnly}T${startTimeOnly}`).format('YYYY-MM-DDTHH:mm:ss'),
      }))
    }
  }, [startDateOnly, startTimeOnly])

  useEffect(() => {
    if (endDateOnly && endTimeOnly) {
      setFormData((prev) => ({
        ...prev,
        endDate: moment(`${endDateOnly}T${endTimeOnly}`).format('YYYY-MM-DDTHH:mm:ss'),
      }))
    }
  }, [endDateOnly, endTimeOnly])

  async function updatePublicity() {
    try {
      if (!id) {
        Swal.fire({
          icon: 'warning',
          title: 'Id não encontrado',
          text: 'Não foi possivel encontrar um id valido'
        }).then(() => navigate(-1))
        return
      }

      setLoadingRequest(true)


      if (!validateForm(formData as CreateAgregatorPublicityDto)) {
        setLoadingRequest(false)
        return
      }

      if (firstStateImage && firstStateImage !== formData.image) {
        await deleteImage(firstStateImage)
      }

      const responseWithImages = await uploadImagesInForm(formData as CreateAgregatorPublicityDto)

      //mesmo se der erro, salvar.
      setFormData(responseWithImages.form)

      if (!responseWithImages || !responseWithImages.success) {
        Swal.fire({
          icon: 'warning',
          title: 'Uns erros acontenceram ao fazer upload das imagens, deseja prosseguir mesmo assim?',
          text: responseWithImages.errors.join(',')
        }).then(async () => {
          await updatePublicityHighLight(parseInt(id), responseWithImages.form)
        })

        return
      }

      // Coloquei any aqui pois grid nao possui ID, então não é possível tipar corretamente, mas o ideal seria tipar corretamente
      await updatePublicityHighLight(parseInt(id), responseWithImages.form)

      console.log('data', responseWithImages.form)

      return navigate(-1)
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao criar página dinâmica',
        text: error ?? 'Um erro inesperado aconteceu, favor observar os logs dentro de suporte'
      })
      console.error('Erro ao criar página dinâmica:', error)
    } finally {
      setLoadingRequest(false)
    }
  }



  const getDateParts = (value?: string) => {
    if (!value) return { date: '', time: '00:00:00' }

    const parsed = moment(value)
    if (!parsed.isValid()) return { date: '', time: '00:00:00' }

    const formatted = parsed.format('YYYY-MM-DD HH:mm:ss')
    const [date, time] = formatted.split(' ')

    return {
      date: date || '',
      time: time || '00:00:00',
    }
  }

  async function loadPage() {
    try {
      if (!id) {
        Swal.fire({
          icon: 'warning',
          title: 'Id não encontrado',
          text: 'Não foi possivel encontrar um id valido'
        }).then(() => navigate(-1))
        return
      }
      setLoading(true)
      const page = await getPublicityHighLightById(parseInt(id))

      setFormData({
        ...page.data,
        pluginSpaceAggregatorId: page.data?.externalLink ? 0 : page.data?.pluginSpaceAggregatorId || 0,
        externalLink: page.data?.externalLink || '',
      })
      setFirstStateImage(page.data?.image || null)
      setHasExternalLink(Boolean(page.data?.externalLink))

      const start = getDateParts(page.data?.startDate)
      const end = getDateParts(page.data?.endDate)
      setStartDateOnly(start.date)
      setStartTimeOnly(start.time)
      setEndDateOnly(end.date)
      setEndTimeOnly(end.time)


      const [stores, classificaiton] = await Promise.all([getAgregadorStores(), getAgregadorClassification()])


      setStores(stores)
      setClassification(classificaiton)

    } catch (error) {
      console.log(error)
      Swal.fire({
        icon: 'warning',
        title: 'Id não encontrado',
        text: 'Não foi possivel encontrar um id valido'
      }).then(() => navigate(-1))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadPage()
  }, [])

  if (loading) return <Loading />


  const getImagetoCrop = (e: any) => {
    if (e?.target.files) {
      setOriginalImageFile(e.target.files[0]) // Armazenar arquivo original
      const url = URL.createObjectURL(e.target.files[0])
      setImageCrop(url)
      showImageCropped()
    }
  }

  const getCropData = async () => {
    if (isCropped) {
      const file = await fetch(isCropped.getCroppedCanvas().toDataURL())
        .then((res) => res.blob())
        .then((blob) => {
          return new File([blob], 'newAvatar.png', { type: 'image/png' })
        })

      const isValid = await validateImage(file)
      if (isValid) {
        handleInputChange('image', isValid)
      } else {
        handleInputChange('image', '')
      }
      setImageCrop('')
    }
  }

  const useOriginalImage = async () => {
    if (originalImageFile) {
      const isValid = await validateImage(originalImageFile)
      if (isValid) {
        handleInputChange('image', isValid)
      } else {
        handleInputChange('image', '')
      }
      setImageCrop('')
      setImageCrop('')
    }
  }

  const useSelectedSize = async (width: number, height: number) => {
    if (originalImageFile) {
      const file = await resizeImage(originalImageFile, width, height)
      if (file) {
        handleInputChange('image', file)
      } else {
        handleInputChange('image', '')
      }
      setImageCrop('')

    }
  }

  if (loading) return <Loading />

  return (
    <div className='card py-4 px-11'>
      <div className='row'>
        <div>
          <h3 className='card-title d-flex align-items-start flex-column'>
             <span className='card-label fw-bolder fs-3 mb-1'>
              {i18n.t('aggregador_publicity.title_edit')}
            </span>
            <BreadCrumbs />
            <span className='text-muted mt-1 fw-bold fs-7'>
              {i18n.t('aggregador_publicity.subTitle_edit')}
            </span>
          </h3>
        </div>

        <div className='col-12 mt-8'>
          {/* Descrição */}
          <div className='row mt-4'>

            <div className='col-7'>
              <Input
                inputAttr={{
                  type: 'default',
                }}
                label={i18n.t('aggregador_publicity.form.title_label')}
                value={formData.title}
                change={(value: string) => handleInputChange('title', value)}
                maxCaracteres={100}
              />
            </div>

            <div className='col-lg-5'>
              <Input
                inputAttr={{ type: 'image-agregador' }}
                label={i18n.t('aggregador_publicity.form.image_label')}
                smalltext='(O tamanho da imagem deve ser 720x600)'
                width='200'
                height='100'
                value={formData.image}
                change={async (value: React.BaseSyntheticEvent | null) => {
                  // Se value é null, o usuário clicou no X para remover a imagem
                  if (!value || !value.target) {
                    handleInputChange('image', '')
                    return
                  }
                  getImagetoCrop(value)
                }}
              />
            </div>
            <div className='col-12'>
              <Input
                inputAttr={{
                  type: 'textarea',
                }}
                label={i18n.t('aggregador_publicity.form.description_label')}
                value={formData.description}
                change={(value: string) => handleInputChange('description', value)}
                maxCaracteres={hasExternalLink ? 250 : 600}
                rows={4}
                smalltext={i18n
                  .t('aggregador_publicity.form.description_smalltext')
                  .replace('{qtd}', hasExternalLink ? '250' : '600')}
              />
            </div>
          </div>

          <div className='row mt-4'>
            <div className='col-6'>
              <Input
                inputAttr={{
                  type: 'select',
                  className: 'form-control',
                }}
                label='Categoria'
                placeholder='Selecione uma categoria para vincular essa página'
                value={formData.aggregatorClassificationId}
                options={[{ select: 'Selecione uma categoria', value: 0 }, ...classification.map(c => ({ select: c.name, value: c.id }))]}
               change={(value: string) => {
                  handleInputChange('aggregatorClassificationId', parseInt(value))
                }}
              />
            </div>
            <div className='col-6'>
              <Input
                inputAttr={{
                  type: 'select',
                  className: 'form-control',
                }}
                label='Local'
                placeholder='Selecione um local'
                value={formData.pluginSpaceAggregatorId}
                 options={[{ select: i18n.t('aggregador_publicity.form.local_placeholder'), value: 0 }, ...stores.map(c => ({ select: c.name, value: c.id }))]}
                change={(value: string) => {
                  setHasExternalLink(false)
                  setFormData((prev) => ({
                    ...prev,
                    pluginSpaceAggregatorId: parseInt(value),
                    externalLink: '',
                  }))
                }}
                disabled={hasExternalLink}
              />
            </div>
          </div>


          <div className='row mt-4'>
            {/* Ordem e Status */}
            <div className='col-md-6'>
              <Input
                inputAttr={{
                  type: 'number',
                  min: '1',
                }}
                label={i18n.t('aggregador_publicity.form.order_label')}
                placeholder={i18n.t('aggregador_publicity.form.order_placeholder')}
                value={formData.order.toString()}
                change={(value: string) => handleInputChange('order', parseInt(value) || 1)}
                smalltext={i18n.t('aggregador_publicity.form.order_smalltext')}
                required
              />
            </div>

            <div className='col-md-6 d-flex align-items-end'>
              <Input
                inputAttr={{
                  type: 'checkbox',
                }}
                label={i18n.t('aggregador_publicity.form.status_label')}
                checked={formData.status}
                change={(checked: boolean) => handleInputChange('status', checked)}
                checkSwift
                smalltext={i18n.t('aggregador_publicity.form.status_smalltext')}
              />
            </div>
          </div>

          {/* Datas */}
          <div className='row mt-4'>
            <div className='col-md-6'>
              <Input
                inputAttr={{
                  type: 'date',
                }}
                label={i18n.t('aggregador_publicity.form.start_date_label')}
                value={startDateOnly}
                change={(value: string) => setStartDateOnly(value)}
                required
                minLength={new Date().toISOString().split('T')[0]} // Data atual ou futura
              />
            </div>

            <div className='col-md-6'>
              <Input
                inputAttr={{
                  type: 'time',
                }}
                label={i18n.t('aggregador_publicity.form.start_time_label')}
                value={startTimeOnly}
                change={(value: string) => setStartTimeOnly(value)}
                required
              />
            </div>
          </div>

          <div className='row mt-4'>
            <div className='col-md-6'>
              <Input
                inputAttr={{
                  type: 'date',
                }}
                label={i18n.t('aggregador_publicity.form.end_date_label')}
                value={endDateOnly}
                change={(value: string) => setEndDateOnly(value)}
                minLength={new Date().toISOString().split('T')[0]}
                required
              />
            </div>

            <div className='col-md-6'>
              <Input
                inputAttr={{
                  type: 'time',
                }}
                label={i18n.t('aggregador_publicity.form.end_time_label')}
                value={endTimeOnly}
                change={(value: string) => setEndTimeOnly(value)}
                required
              />
            </div>
          </div>

          {/* Preview das datas */}
          {formData.startDate && formData.endDate && (
            <div className='row mt-4'>
              <div className='col-12'>
                <div className='alert alert-info'>
                  <h6 className='mb-2'>
                    📅 {i18n.t('aggregador_publicity.preview.period_title')}
                  </h6>
                  <p className='mb-1'>
                    <strong>{i18n.t('aggregador_publicity.preview.start')}:</strong>{' '}
                    {moment(formData.startDate).isValid() ? moment(formData.startDate).format('DD/MM/YYYY HH:mm:ss') : '—'}
                  </p>
                  <p className='mb-0'>
                    <strong>{i18n.t('aggregador_publicity.preview.end')}:</strong>{' '}
                    {moment(formData.endDate).isValid() ? moment(formData.endDate).format('DD/MM/YYYY HH:mm:ss') : '—'}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Link Externo */}
          <div className='row mt-4'>
            <div className='col-12'>
              <Input
                inputAttr={{
                  type: 'checkbox',
                }}
                label={i18n.t('aggregador_publicity.form.external_link_checkbox')}
                checked={hasExternalLink}
                change={(checked: boolean) => {
                  setHasExternalLink(checked)
                  handleInputChange(checked ? 'pluginSpaceAggregatorId' : 'externalLink', checked ? 0 : '')
                  if (checked) {
                    handleInputChange('description', formData.description.substring(0, 250))
                  }
                }}
                checkSwift
              />
              {hasExternalLink && (
                <div className='mt-3'>
                  <Input
                    inputAttr={{
                      type: 'text',
                      placeholder: 'https://example.com',
                    }}
                    label={i18n.t('aggregador_publicity.form.external_link_label')}
                    placeholder={i18n.t(
                      'aggregador_publicity.form.external_link_placeholder'
                    )}
                    value={formData.externalLink}
                    change={(value: string) => {
                      handleInputChange('externalLink', value)
                    }}
                    required
                    maxCaracteres={250}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Botões de Ação */}
      <div className='d-flex justify-content-between pt-8 mt-8 border-top'>
        <Button
          text={i18n.t(`buttons.back`)}
          color='info'
          size='small'
          horizontalPadding={6}
          btnAttr={{
            type: 'button',
          }}
          click={() => navigate(-1)}
          btnClass='fw-bolder'
          disabled={loadingRequest}
        />
        <Button
          text={i18n.t(`buttons.save`)}
          color='primary'
          size='small'
          horizontalPadding={5}
          btnAttr={{
            type: 'button',
          }}
          click={() => updatePublicity()}
          disabled={loadingRequest}
          btnClass='fw-bolder'
        />
      </div>

      <ModalImagemCropped
        imageCrop={imageCrop}
        setCropper={setCropper}
        getCropData={getCropData}
        onUseOriginalImage={useOriginalImage}
        onUseSelectedSize={useSelectedSize}
        croppedOptions={[{ width: 720, height: 600, value: '720x600' }]}
      />
    </div>
  )
}

export { AgregadorPublicityHighLightsEditar }
